import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DbaRoute } from '@definitiv-packages/angular-dba-library';

import { DebtorListViewComponent } from './views/debtor-list-view/debtor-list-view.component';
import { ObjectServiceViewComponent } from './views/object-service-view/object-service-view.component';
import { TodosViewComponent } from './views/todos-view/todos-view.component';
import { DebtorViewComponent } from './views/debtor-view/debtor-view.component';
import { ObjectViewComponent } from './views/object-view/object-view.component';
import { SafetypointVerwaltungMenuComponent } from './views/safetypoint-verwaltung-menu/safetypoint-verwaltung-menu.component';
import { SafetypointSucheViewComponent } from './views/safetypoint-suche-view/safetypoint-suche-view.component';
import { CreateSafetyPointComponent } from '../../../roofsafetymanagement-library/src/public-api';

var routes: DbaRoute<void>[] = [
  { path: '', component: SafetypointVerwaltungMenuComponent, title: "Home" },
  { path: 'SafetypointSuche' , component: SafetypointSucheViewComponent, title: "Suche"},
  


  { path: 'debtor-list', component: DebtorListViewComponent, title: "debitoren" },
  { path: 'debtor/:debtorId', component: DebtorViewComponent, title: "debitor" },
  { path: 'object/:objectId', component: ObjectViewComponent, title: "Dachflaechen" },
  { path: 'object-service/:objectId', component: ObjectServiceViewComponent, title: "ObjektService" }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
